export default __webpack_public_path__ + "assets/a20adf9d21d5b592dda9c81a862e998d.svg";